import ReactDOM from 'react-dom';
export const getFilteredData = ({ data, search, filters, columns, }) => data.filter((entry) => {
    if (!search && !filters.length) {
        return true;
    }
    return doesEntryPassFilters({
        entry,
        filters,
    }) && doesEntryPassSearchFilter({
        entry,
        search,
        columns,
    });
});
export const doesEntryPassFilters = ({ entry, filters, }) => filters.every((f) => {
    var _a, _b;
    const value = entry[f.property];
    if (value === undefined) {
        return false;
    }
    if ((!f.meta && !f.value && f.value !== false) || (Array.isArray(f.meta) && !((_a = f.meta) === null || _a === void 0 ? void 0 : _a.length))) {
        return true;
    }
    if (Array.isArray(f.meta)) {
        return f.meta.find((item) => item.text === value);
    }
    return (((_b = f.meta) === null || _b === void 0 ? void 0 : _b.text) === value || f.value === value);
});
export const doesEntryPassSearchFilter = ({ entry, search, columns, }) => Object
    .entries(entry)
    .filter(([key]) => !!columns.find(c => c.property === key && c.searchable))
    .map(([, value]) => value)
    .filter(v => !!v)
    .some((value) => value.toString().toLowerCase()
    .includes(search.toLowerCase()));
export const elementToNode = (element) => {
    const div = document.createElement('div');
    ReactDOM.render(element, div);
    return div;
};
//# sourceMappingURL=utils.js.map